import { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LOGIN_ROUTE } from "../../routes/RoutesPathes";
import styles from "./forms.module.css";
import { requestPasswordResetAPI } from "../../services/authService";

export const RequestPasswordReset = () => {
  const emailRef = useRef();
  const { t, i18n } = useTranslation();
  const arrow = i18n.dir() === "rtl" ? "←" : "→";

  const [email, setEmail] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    emailRef?.current?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);

    try {
      setLoading(true);
      await requestPasswordResetAPI(email);
      setEmail("");
      setSuccess(true);
    } catch (err) {
      setErrMsg(t("titles.something_went_wrong"));
      if (err?.response?.status === 404) {
        setErrMsg(t("forms.password_reset.not_registered"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ marginTop: "7rem" }}
    >
      <Row className="w-100 justify-content-center">
        <Col md={6} lg={5}>
          <Card className="p-4">
            {success ? (
              <div className="text-center">
                <h3>{t("forms.password_reset.email_sent_title")}</h3>
                <p className="text-muted mb-4">
                  {t("forms.password_reset.email_sent_body")}
                </p>
                <p>
                  <Link to={LOGIN_ROUTE} className="s-link s-purple-link">
                    {t("buttons.login")} {arrow}
                  </Link>
                </p>
              </div>
            ) : (
              <>
                <h4 className="mb-3 text-center">
                  {t("forms.password_reset.title")}
                </h4>
                <p className="text-muted text-center mb-4">
                  {t("forms.password_reset.body")}
                </p>
                <Form onSubmit={handleSubmit}>
                  <Form.Group as={Col} md="12">
                    <Form.Control
                      className={styles.formInput}
                      type="email"
                      required
                      placeholder={t("forms.password_reset.email_placeholder")}
                      ref={emailRef}
                      value={email}
                      maxLength={100}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>

                  <Button
                    className={`${styles.formBtn} btn-secondary mt-4 w-100`}
                    type="submit"
                    disabled={loading}
                  >
                    {loading
                      ? t("buttons.sending")
                      : t("buttons.send_reset_password")}
                  </Button>
                  {errMsg && (
                    <Alert variant="danger" className="mt-3 mb-0">
                      <p className="m-0" style={{ fontSize: "1rem" }}>
                        {errMsg}
                      </p>
                    </Alert>
                  )}
                </Form>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
